// Push notification subscription helpers.
// Registers the service worker's push manager with our VAPID public key and
// POSTs the subscription to /api/push/subscribe.

import axios from "axios";
import { BACKEND_URL } from "@/lib/backendUrl";

const API = `${BACKEND_URL}/api`;

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export async function subscribeToPush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return false;
  const reg = await navigator.serviceWorker.ready;
  const existing = await reg.pushManager.getSubscription();
  if (existing) {
    // ensure server knows
    try { await axios.post(`${API}/push/subscribe`, existing.toJSON()); } catch {}
    return true;
  }
  // Request permission
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return false;
  const { data } = await axios.get(`${API}/push/vapid-public-key`);
  if (!data.public_key) return false;
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.public_key),
  });
  await axios.post(`${API}/push/subscribe`, sub.toJSON());
  return true;
}

export async function unsubscribeFromPush() {
  if (!("serviceWorker" in navigator)) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;
  try { await axios.post(`${API}/push/unsubscribe`, sub.toJSON()); } catch {}
  await sub.unsubscribe();
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export function pushPermission() {
  return typeof Notification !== "undefined" ? Notification.permission : "unsupported";
}
